export const dp_app_negative_brightest = 'rgba(255, 239, 240, 1)';
export const dp_app_negative_brighter = 'rgba(255, 229, 230, 1)';
export const dp_app_negative_bright = 'rgba(255, 157, 161, 1)';
export const dp_app_negative_mid = 'rgba(239, 55, 14, 1)';
export const dp_app_negative_dull = 'rgba(199, 13, 0, 1)';
export const dp_app_negative_duller = 'rgba(149, 10, 0, 1)';
export const dp_app_negative_dullest = 'rgba(115, 3, 3, 1)';
export const dp_app_warning_brightest = 'rgba(253, 247, 201, 1)';
export const dp_app_warning_brighter = 'rgba(255, 246, 177, 1)';
export const dp_app_warning_bright = 'rgba(252, 236, 131, 1)';
export const dp_app_warning_mid = 'rgba(255, 197, 8, 1)';
export const dp_app_warning_dull = 'rgba(213, 128, 0, 1)';
export const dp_app_warning_duller = 'rgba(149, 82, 0, 1)';
export const dp_app_warning_dullest = 'rgba(80, 46, 0, 1)';
export const dp_app_info_brightest = 'rgba(235, 242, 255, 1)';
export const dp_app_info_brighter = 'rgba(223, 235, 255, 1)';
export const dp_app_info_bright = 'rgba(120, 163, 255, 1)';
export const dp_app_info_mid = 'rgba(0, 79, 249, 1)';
export const dp_app_info_dull = 'rgba(0, 53, 169, 1)';
export const dp_app_info_duller = 'rgba(0, 36, 114, 1)';
export const dp_app_info_dullest = 'rgba(0, 24, 72, 1)';
export const dp_app_positive_brightest = 'rgba(225, 251, 215, 1)';
export const dp_app_positive_brighter = 'rgba(214, 243, 203, 1)';
export const dp_app_positive_bright = 'rgba(115, 219, 94, 1)';
export const dp_app_positive_mid = 'rgba(17, 172, 35, 1)';
export const dp_app_positive_dull = 'rgba(12, 115, 43, 1)';
export const dp_app_positive_duller = 'rgba(15, 76, 35, 1)';
export const dp_app_positive_dullest = 'rgba(5, 45, 18, 1)';
export const dp_app_selection_brightest = 'rgba(243, 241, 253, 1)';
export const dp_app_selection_brighter = 'rgba(236, 232, 252, 1)';
export const dp_app_selection_bright = 'rgba(213, 206, 247, 1)';
export const dp_app_selection_mid = 'rgba(151, 134, 230, 1)';
export const dp_app_selection_dim = 'rgba(76, 79, 223, 1)';
export const dp_app_selection_dull = 'rgba(35, 50, 196, 1)';
export const dp_app_selection_duller = 'rgba(45, 0, 177, 1)';
export const dp_app_selection_dullest = 'rgba(22, 0, 120, 1)';
export const dp_app_text_base = 'rgba(25, 35, 37, 1)';
export const dp_app_text_subtle = 'rgba(63, 75, 78, 1)';
export const dp_app_text_subdued = 'rgba(91, 100, 102, 1)';
export const dp_app_text_inverted = 'rgba(255, 255, 255, 1)';
export const dp_app_text_base_inverted = 'rgba(255, 255, 255, 1)';
export const dp_app_text_negative = 'rgba(199, 13, 0, 1)';
export const dp_app_text_warning = 'rgba(149, 82, 0, 1)';
export const dp_app_text_positive = 'rgba(12, 115, 43, 1)';
export const dp_app_text_disabled = 'rgba(91, 100, 102, 1)';
export const dp_app_text_urgency_medium = 'rgba(149, 82, 0, 1)';
export const dp_app_text_urgency_high = 'rgba(199, 13, 0, 1)';
export const dp_app_link_base = 'rgba(0, 79, 249, 1)';
export const dp_app_link_hover = 'rgba(0, 53, 169, 1)';
export const dp_app_link_pressed = 'rgba(0, 24, 72, 1)';
export const dp_app_link_visited_base = 'rgba(45, 0, 177, 1)';
export const dp_app_link_visited = 'rgba(45, 0, 177, 1)';
export const dp_app_link_visited_hover = 'rgba(35, 50, 196, 1)';
export const dp_app_link_visited_pressed = 'rgba(22, 0, 120, 1)';
export const dp_app_backdrop_base = 'rgba(255, 255, 255, 1)';
export const dp_app_backdrop_white = 'rgba(255, 255, 255, 1)';
export const dp_app_backdrop_dull = 'rgba(242, 244, 244, 1)';
export const dp_app_backdrop_base_brightest = 'rgba(242, 244, 244, 1)';
export const dp_app_backdrop_duller = 'rgba(231, 235, 235, 1)';
export const dp_app_backdrop_base_brighter = 'rgba(231, 235, 235, 1)';
export const dp_app_backdrop_one_brightest = 'rgba(255, 239, 223, 1)';
export const dp_app_backdrop_one_brighter = 'rgba(255, 230, 207, 1)';
export const dp_app_backdrop_one_duller = 'rgba(149, 10, 0, 1)';
export const dp_app_backdrop_one_dullest = 'rgba(115, 3, 3, 1)';
export const dp_app_backdrop_two_brightest = 'rgba(253, 247, 201, 1)';
export const dp_app_backdrop_two_brighter = 'rgba(255, 246, 177, 1)';
export const dp_app_backdrop_two_duller = 'rgba(149, 82, 0, 1)';
export const dp_app_backdrop_two_dullest = 'rgba(80, 46, 0, 1)';
export const dp_app_backdrop_three_brightest = 'rgba(235, 242, 255, 1)';
export const dp_app_backdrop_three_brighter = 'rgba(223, 235, 255, 1)';
export const dp_app_backdrop_three_duller = 'rgba(0, 36, 114, 1)';
export const dp_app_backdrop_three_dullest = 'rgba(0, 24, 72, 1)';
export const dp_app_backdrop_four_brightest = 'rgba(225, 251, 215, 1)';
export const dp_app_backdrop_four_brighter = 'rgba(214, 243, 203, 1)';
export const dp_app_backdrop_four_duller = 'rgba(9, 57, 17, 1)';
export const dp_app_backdrop_four_dullest = 'rgba(5, 45, 18, 1)';
export const dp_app_border_base = 'rgba(208, 212, 213, 1)';
export const dp_app_border_bright = 'rgba(242, 244, 244, 1)';
export const dp_app_border_dull = 'rgba(138, 148, 151, 1)';
export const dp_app_action_primary = 'rgba(0, 168, 143, 1)';
export const dp_app_co2_banner_background = 'rgba(226, 246, 240, 1)';
export const dp_app_co2_banner_background_hover = 'rgba(211, 241, 232, 1)';
export const dp_app_co2_banner_action_icon_fill = 'rgba(0, 112, 95, 1)';
export const dp_app_co2_banner_body = 'rgba(0, 112, 95, 1)';
export const dp_app_action_secondary = 'rgba(35, 50, 196, 1)';
export const dp_app_action_tertiary = 'rgba(255, 255, 255, 1)';
export const dp_app_action_destructive = 'rgba(199, 13, 0, 1)';
export const dp_app_action_disabled = 'rgba(231, 235, 235, 1)';
export const dp_app_focus_ring = 'rgba(35, 50, 196, 0.48)';
export const dp_app_focus_ring_inverted = 'rgba(213, 206, 247, 0.88)';
export const dp_app_box_shadow = 'rgba(5, 45, 18, 0.12)';
export const dp_app_overlay_backdrop_dim = 'rgba(25, 35, 37, 0.24)';
export const dp_app_overlay_backdrop_dull = 'rgba(25, 35, 37, 0.48)';
export const dp_app_overlay_backdrop_dullest = 'rgba(25, 35, 37, 0.8)';
export const dp_app_modal_background = 'rgba(255, 255, 255, 1)';
export const dp_app_button_primary_background = 'rgba(0, 168, 143, 1)';
export const dp_app_button_primary_background_hover = 'rgba(0, 112, 95, 1)';
export const dp_app_button_primary_background_pressed = 'rgba(0, 62, 52, 1)';
export const dp_app_button_secondary_background = 'rgba(35, 50, 196, 1)';
export const dp_app_button_secondary_background_hover = 'rgba(45, 0, 177, 1)';
export const dp_app_button_secondary_background_pressed = 'rgba(22, 0, 120, 1)';
export const dp_app_button_tertiary_background = 'rgba(255, 255, 255, 1)';
export const dp_app_button_tertiary_background_hover = 'rgba(242, 244, 244, 1)';
export const dp_app_button_tertiary_background_pressed = 'rgba(208, 212, 213, 1)';
export const dp_app_button_tertiary_border = 'rgba(208, 212, 213, 1)';
export const dp_app_message_info_background = 'rgba(235, 242, 255, 1)';
export const dp_app_message_info_left_edge = 'rgba(0, 79, 249, 1)';
export const dp_app_message_info_border = 'rgba(120, 163, 255, 1)';
export const dp_app_message_positive_background = 'rgba(225, 251, 215, 1)';
export const dp_app_message_positive_left_edge = 'rgba(17, 172, 35, 1)';
export const dp_app_message_positive_border = 'rgba(115, 219, 94, 1)';
export const dp_app_message_warning_background = 'rgba(253, 247, 201, 1)';
export const dp_app_message_warning_left_edge = 'rgba(255, 197, 8, 1)';
export const dp_app_message_warning_border = 'rgba(255, 197, 8, 1)';
export const dp_app_message_negative_background = 'rgba(255, 239, 240, 1)';
export const dp_app_message_negative_left_edge = 'rgba(239, 55, 14, 1)';
export const dp_app_message_negative_border = 'rgba(255, 157, 161, 1)';
export const dp_app_carrier_logo_monochrome_fill = 'rgba(138, 148, 151, 1)';
export const dp_app_search_form_background = 'rgba(0, 24, 72, 1)';
export const dp_app_text_field_border = 'rgba(138, 148, 151, 1)';
export const dp_app_text_field_border_hover = 'rgba(76, 79, 223, 1)';
export const dp_app_text_field_border_focus = 'rgba(35, 50, 196, 1)';
export const dp_app_text_field_border_invalid = 'rgba(239, 55, 14, 1)';
export const dp_app_text_field_placeholder = 'rgba(91, 100, 102, 1)';
export const dp_app_text_subtle_inverted = 'rgba(231, 235, 235, 1)';
export const dp_app_text_subdued_inverted = 'rgba(208, 212, 213, 1)';
export const dp_app_backdrop_black = 'rgba(0, 0, 0, 1)';
export const dp_app_backdrop_base_duller = 'rgba(47, 56, 58, 1)';
export const dp_app_backdrop_base_dullest = 'rgba(25, 35, 37, 1)';
export const dp_app_backdrop_primary_brightest = 'rgba(226, 246, 240, 1)';
export const dp_app_backdrop_primary_brighter = 'rgba(211, 241, 232, 1)';
export const dp_app_backdrop_primary_duller = 'rgba(0, 44, 37, 1)';
export const dp_app_backdrop_primary_dullest = 'rgba(0, 38, 32, 1)';
export const dp_app_backdrop_secondary_brightest = 'rgba(243, 241, 253, 1)';
export const dp_app_backdrop_secondary_brighter = 'rgba(236, 232, 252, 1)';
export const dp_app_backdrop_secondary_duller = 'rgba(45, 0, 177, 1)';
export const dp_app_backdrop_secondary_dullest = 'rgba(22, 0, 120, 1)';
export const dp_app_backdrop_tertiary_brightest = 'rgba(255, 239, 240, 1)';
export const dp_app_backdrop_tertiary_brighter = 'rgba(255, 229, 230, 1)';
export const dp_app_backdrop_tertiary_duller = 'rgba(102, 0, 52, 1)';
export const dp_app_backdrop_tertiary_dullest = 'rgba(72, 0, 37, 1)';
export const dp_app_button_destructive_background = 'rgba(199, 13, 0, 1)';
export const dp_app_button_destructive_background_hover = 'rgba(149, 10, 0, 1)';
export const dp_app_button_destructive_background_pressed = 'rgba(115, 3, 3, 1)';
export const dp_app_button_promo1_background = 'rgba(255, 157, 161, 1)';
export const dp_app_button_promo1_background_hover = 'rgba(255, 92, 98, 1)';
export const dp_app_button_promo1_background_pressed = 'rgba(255, 229, 230, 1)';
export const dp_app_button_promo2_background = 'rgba(25, 35, 37, 1)';
export const dp_app_button_promo2_background_hover = 'rgba(47, 56, 58, 1)';
export const dp_app_button_promo2_background_pressed = 'rgba(63, 75, 78, 1)';
export const dp_app_button_transparent_background = 'rgba(25, 35, 37, 0)';
export const dp_app_button_transparent_background_hover = 'rgba(25, 35, 37, 0.08)';
export const dp_app_button_transparent_background_pressed = 'rgba(25, 35, 37, 0.24)';
export const dp_app_inline_text_button_label = 'rgba(35, 50, 196, 1)';
export const dp_app_inline_text_button_label_inverted = 'rgba(213, 206, 247, 1)';
export const dp_app_message_primary_background = 'rgba(226, 246, 240, 1)';
export const dp_app_message_primary_border = 'rgba(160, 223, 209, 1)';
export const dp_app_message_secondary_background = 'rgba(243, 241, 253, 1)';
export const dp_app_message_neutral_background = 'rgba(242, 244, 244, 1)';
export const dp_app_message_neutral_border = 'rgba(208, 212, 213, 1)';
export const dp_app_message_action_icon_fill = 'rgba(138, 148, 151, 1)';
export const dp_app_selectable_text = 'rgba(63, 75, 78, 1)';
export const dp_app_selectable_background_base = 'rgba(255, 255, 255, 1)';
export const dp_app_selectable_background_hover = 'rgba(243, 241, 253, 1)';
export const dp_app_selectable_background_pressed = 'rgba(236, 232, 252, 1)';
export const dp_app_selectable_disabled_background = 'rgba(231, 235, 235, 1)';
export const dp_app_selectable_border_base = 'rgba(208, 212, 213, 1)';
export const dp_app_selectable_border_dull = 'rgba(138, 148, 151, 1)';
export const dp_app_selectable_border_hover = 'rgba(76, 79, 223, 1)';
export const dp_app_selectable_border_pressed = 'rgba(76, 79, 223, 1)';
export const dp_app_selectable_border_invalid = 'rgba(239, 55, 14, 1)';
export const dp_app_selected_text = 'rgba(35, 50, 196, 1)';
export const dp_app_selected_background_base = 'rgba(243, 241, 253, 1)';
export const dp_app_selected_background_dull = 'rgba(35, 50, 196, 1)';
export const dp_app_selected_background_hover = 'rgba(45, 0, 177, 1)';
export const dp_app_selected_background_pressed = 'rgba(22, 0, 120, 1)';
export const dp_app_selected_border_base = 'rgba(35, 50, 196, 1)';
export const dp_app_selected_border_hover = 'rgba(45, 0, 177, 1)';
export const dp_app_selected_border_pressed = 'rgba(22, 0, 120, 1)';
export const dp_app_spinner_background_base = 'rgba(35, 50, 196, 1)';
export const dp_app_spinner_background_inverted = 'rgba(255, 255, 255, 1)';
export const dp_app_text_field_background_base = 'rgba(255, 255, 255, 1)';
export const dp_app_text_field_background_disabled = 'rgba(231, 235, 235, 1)';
export const dp_app_text_field_label_base = 'rgba(25, 35, 37, 1)';
export const dp_app_text_field_label_focus = 'rgba(35, 50, 196, 1)';
export const dp_app_text_field_icon_fill_base = 'rgba(91, 100, 102, 1)';
export const dp_app_text_field_icon_fill_brighter = 'rgba(138, 148, 151, 1)';
export const dp_app_icon_fill_base = 'rgba(25, 35, 37, 1)';
export const dp_app_icon_fill_subtle = 'rgba(91, 100, 102, 1)';
export const dp_app_icon_fill_subdued = 'rgba(138, 148, 151, 1)';
export const dp_app_icon_fill_inverted = 'rgba(255, 255, 255, 1)';
export const dp_app_overlay_background_base = 'rgba(255, 255, 255, 1)';
export const dp_app_overlay_background_inverted = 'rgba(25, 35, 37, 1)';
export const dp_app_tooltip_background = 'rgba(25, 35, 37, 1)';
export const dp_app_snackbar_background = 'rgba(25, 35, 37, 1)';
export const dp_app_bubble_background = 'rgba(255, 255, 255, 1)';
export const dp_app_header_background_secondary = 'rgba(22, 0, 120, 1)';
export const dp_app_text_tlb_brand_primary = 'rgba(122, 103, 211, 1)';
export const dp_brand_primary_core = 'rgba(0, 168, 143, 1)';
export const dp_brand_primary_brightest = 'rgba(226, 246, 240, 1)';
export const dp_brand_primary_brighter = 'rgba(211, 241, 232, 1)';
export const dp_brand_primary_bright = 'rgba(160, 223, 209, 1)';
export const dp_brand_primary_mid = 'rgba(0, 168, 143, 1)';
export const dp_brand_primary_dim = 'rgba(0, 112, 95, 1)';
export const dp_brand_primary_dull = 'rgba(0, 62, 52, 1)';
export const dp_brand_primary_duller = 'rgba(0, 44, 37, 1)';
export const dp_brand_primary_dullest = 'rgba(0, 38, 32, 1)';
export const dp_brand_secondary_core = 'rgba(35, 50, 196, 1)';
export const dp_brand_secondary_brightest = 'rgba(243, 241, 253, 1)';
export const dp_brand_secondary_brighter = 'rgba(236, 232, 252, 1)';
export const dp_brand_secondary_bright = 'rgba(213, 206, 247, 1)';
export const dp_brand_secondary_mid = 'rgba(151, 134, 230, 1)';
export const dp_brand_secondary_dim = 'rgba(76, 79, 223, 1)';
export const dp_brand_secondary_dull = 'rgba(35, 50, 196, 1)';
export const dp_brand_secondary_duller = 'rgba(45, 0, 177, 1)';
export const dp_brand_secondary_dullest = 'rgba(22, 0, 120, 1)';
export const dp_brand_tertiary_core = 'rgba(255, 157, 161, 1)';
export const dp_brand_tertiary_brightest = 'rgba(255, 239, 240, 1)';
export const dp_brand_tertiary_brighter = 'rgba(255, 229, 230, 1)';
export const dp_brand_tertiary_bright = 'rgba(255, 157, 161, 1)';
export const dp_brand_tertiary_mid = 'rgba(255, 92, 98, 1)';
export const dp_brand_tertiary_dim = 'rgba(197, 0, 79, 1)';
export const dp_brand_tertiary_dull = 'rgba(147, 0, 71, 1)';
export const dp_brand_tertiary_duller = 'rgba(102, 0, 52, 1)';
export const dp_brand_tertiary_dullest = 'rgba(72, 0, 37, 1)';
export const dp_brand_neutral_core = 'rgba(25, 35, 37, 1)';
export const dp_brand_neutral_brightest = 'rgba(242, 244, 244, 1)';
export const dp_brand_neutral_brighter = 'rgba(231, 235, 235, 1)';
export const dp_brand_neutral_bright = 'rgba(208, 212, 213, 1)';
export const dp_brand_neutral_mid = 'rgba(138, 148, 151, 1)';
export const dp_brand_neutral_dim = 'rgba(91, 100, 102, 1)';
export const dp_brand_neutral_dull = 'rgba(63, 75, 78, 1)';
export const dp_brand_neutral_duller = 'rgba(47, 56, 58, 1)';
export const dp_brand_neutral_dullest = 'rgba(25, 35, 37, 1)';
export const dp_brand_white = 'rgba(255, 255, 255, 1)';
export const dp_brand_black = 'rgba(0, 0, 0, 1)';
export const dp_brand_negative_brightest = 'rgba(255, 239, 240, 1)';
export const dp_brand_negative_brighter = 'rgba(255, 229, 230, 1)';
export const dp_brand_negative_bright = 'rgba(255, 157, 161, 1)';
export const dp_brand_negative_mid = 'rgba(239, 55, 14, 1)';
export const dp_brand_negative_dull = 'rgba(199, 13, 0, 1)';
export const dp_brand_negative_duller = 'rgba(149, 10, 0, 1)';
export const dp_brand_negative_dullest = 'rgba(115, 3, 3, 1)';
export const dp_brand_warning_brightest = 'rgba(253, 247, 201, 1)';
export const dp_brand_warning_brighter = 'rgba(255, 246, 177, 1)';
export const dp_brand_warning_bright = 'rgba(252, 236, 131, 1)';
export const dp_brand_warning_mid = 'rgba(255, 197, 8, 1)';
export const dp_brand_warning_dull = 'rgba(213, 128, 0, 1)';
export const dp_brand_warning_duller = 'rgba(149, 82, 0, 1)';
export const dp_brand_warning_dullest = 'rgba(80, 46, 0, 1)';
export const dp_brand_info_brightest = 'rgba(235, 242, 255, 1)';
export const dp_brand_info_brighter = 'rgba(223, 235, 255, 1)';
export const dp_brand_info_bright = 'rgba(120, 163, 255, 1)';
export const dp_brand_info_mid = 'rgba(0, 79, 249, 1)';
export const dp_brand_info_dull = 'rgba(0, 53, 169, 1)';
export const dp_brand_info_duller = 'rgba(0, 36, 114, 1)';
export const dp_brand_info_dullest = 'rgba(0, 24, 72, 1)';
export const dp_brand_positive_brightest = 'rgba(225, 251, 215, 1)';
export const dp_brand_positive_brighter = 'rgba(214, 243, 203, 1)';
export const dp_brand_positive_bright = 'rgba(115, 219, 94, 1)';
export const dp_brand_positive_mid = 'rgba(17, 172, 35, 1)';
export const dp_brand_positive_dull = 'rgba(12, 115, 43, 1)';
export const dp_brand_positive_duller = 'rgba(15, 76, 35, 1)';
export const dp_brand_positive_dullest = 'rgba(5, 45, 18, 1)';
export const dp_comp_button_primary_background = 'rgba(0, 168, 143, 1)';
export const dp_comp_button_primary_background_hover = 'rgba(0, 112, 95, 1)';
export const dp_comp_button_primary_background_pressed = 'rgba(0, 62, 52, 1)';
export const dp_comp_button_secondary_background = 'rgba(35, 50, 196, 1)';
export const dp_comp_button_secondary_background_hover = 'rgba(45, 0, 177, 1)';
export const dp_comp_button_secondary_background_pressed = 'rgba(22, 0, 120, 1)';
export const dp_comp_button_tertiary_background = 'rgba(255, 255, 255, 1)';
export const dp_comp_button_tertiary_background_hover = 'rgba(242, 244, 244, 1)';
export const dp_comp_button_tertiary_background_pressed = 'rgba(208, 212, 213, 1)';
export const dp_comp_table_row = 'rgba(242, 244, 244, 1)';
export const dp_comp_table_row_hover = 'rgba(226, 246, 240, 1)';
export const dp_comp_table_row_active_border = 'rgba(0, 168, 143, 1)';
export const dp_comp_skeleton_background_base = 'rgba(242, 244, 244, 1)';
export const dp_comp_skeleton_background_duller = 'rgba(231, 235, 235, 1)';
export const dp_comp_message_negative_background = 'rgba(255, 239, 240, 1)';
export const dp_comp_message_negative_left_edge = 'rgba(239, 55, 14, 1)';
export const dp_comp_message_negative_border = 'rgba(255, 157, 161, 1)';
export const dp_comp_message_warning_background = 'rgba(253, 247, 201, 1)';
export const dp_comp_message_warning_left_edge = 'rgba(255, 197, 8, 1)';
export const dp_comp_message_warning_border = 'rgba(255, 197, 8, 1)';
export const dp_comp_message_info_background = 'rgba(235, 242, 255, 1)';
export const dp_comp_message_info_left_edge = 'rgba(0, 79, 249, 1)';
export const dp_comp_message_info_border = 'rgba(120, 163, 255, 1)';
export const dp_comp_message_positive_background = 'rgba(225, 251, 215, 1)';
export const dp_comp_message_positive_left_edge = 'rgba(17, 172, 35, 1)';
export const dp_comp_message_positive_border = 'rgba(115, 219, 94, 1)';
export const dp_comp_input_border = 'rgba(208, 212, 213, 1)';
export const dp_comp_input_border_hover = 'rgba(76, 79, 223, 1)';
export const dp_comp_input_border_focus = 'rgba(35, 50, 196, 1)';
export const dp_comp_input_invalid_border = 'rgba(239, 55, 14, 1)';
export const dp_comp_input_invalid_border_hover = 'rgba(199, 13, 0, 1)';
export const dp_comp_input_invalid_border_focus = 'rgba(239, 55, 14, 1)';
export const dp_comp_input_placeholder_text = 'rgba(91, 100, 102, 1)';
export const dp_comp_carrier_logo_monochrome_fill = 'rgba(138, 148, 151, 1)';
export const dp_comp_focus_ring = 'rgba(35, 50, 196, 0.5)';
export const dp_comp_box_shadow = 'rgba(5, 45, 18, 0.12)';
export const dp_comp_input_binary_background_base = 'rgba(255, 255, 255, 1)';
export const dp_comp_input_binary_background_hover = 'rgba(236, 232, 252, 1)';
export const dp_comp_input_binary_background_pressed = 'rgba(213, 206, 247, 1)';
export const dp_comp_input_binary_border_base = 'rgba(138, 148, 151, 1)';
export const dp_comp_input_binary_border_hover = 'rgba(76, 79, 223, 1)';
export const dp_comp_input_binary_border_pressed = 'rgba(76, 79, 223, 1)';
export const dp_comp_input_binary_selected_background_base = 'rgba(35, 50, 196, 1)';
export const dp_comp_input_binary_selected_background_hover = 'rgba(45, 0, 177, 1)';
export const dp_comp_input_binary_selected_background_pressed = 'rgba(22, 0, 120, 1)';
export const dp_comp_input_binary_selected_border_base = 'rgba(35, 50, 196, 1)';
export const dp_comp_journey_search_form_bg = 'rgba(0, 24, 72, 1)';
export const dp_comp_quick_buy_button_bg = 'rgba(0, 24, 72, 1)';
export const dp_comp_journey_summary_header_bg = 'rgba(0, 24, 72, 1)';
export const dp_comp_swap_stations = 'rgba(0, 24, 72, 1)';
export const dp_comp_time_picker_disabled = 'rgba(0, 24, 72, 1)';
export const dp_comp_eu_trip_header_bg = 'rgba(0, 24, 72, 1)';
export const dp_comp_confirmation_header_bg = 'rgba(0, 62, 52, 1)';
export const dp_comp_basic_header_bg = 'rgba(255, 255, 255, 1)';
